import { useMutation } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { setCommissionPlan } from 'services/plan'

export default function useSetCommission() {
    const { moneyPool } = useParams()
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: number) => {
            return setCommissionPlan(payload)
        },
        onSuccess: (data, variable) => {
            toast.success('صندوق شما با موفقیت به کارمزدی تغییر کرد')
            navigate(`/fund/${moneyPool}`)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
